var getLinearGradient = function(gradient) {
    var direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0deg";
    if (gradient === null || gradient === void 0 ? void 0 : gradient.via) {
        return "linear-gradient(".concat(direction, ", ").concat(gradient === null || gradient === void 0 ? void 0 : gradient.from, ", ").concat(gradient === null || gradient === void 0 ? void 0 : gradient.via, ", ").concat(gradient === null || gradient === void 0 ? void 0 : gradient.to, ")");
    }
    return "linear-gradient(".concat(direction, ", ").concat(gradient === null || gradient === void 0 ? void 0 : gradient.from, ", ").concat(gradient === null || gradient === void 0 ? void 0 : gradient.to, ")");
};
export { getLinearGradient };
